// FAQ data — kept as a single source so /faq page and /services section stay in sync.
// Order matters: the most-searched questions appear first.
export const faqs = [
  {
    q: "How does online boxing coaching work?",
    a: "Every session is a private, live Zoom call with Coach Chris — not a pre-recorded video. He watches you in real time, corrects your stance, footwork, and punches as you go, and adjusts the workout to your level. It's the same coaching you'd get in a boxing gym, delivered from wherever you are.",
    keywords: ["online boxing coach", "zoom boxing coaching", "virtual boxing lessons"],
  },
  {
    q: "Are virtual boxing lessons effective for complete beginners?",
    a: "Yes — beginners actually get the most out of this format. There's no gym intimidation, no rushed group classes, and no skipping over fundamentals. Coach Chris specializes in making the basics feel accessible: stance, footwork, the Core 4 punches, and defense. Most clients say they learn more in one private Zoom session than weeks of group classes.",
    keywords: ["boxing coach for beginners", "virtual boxing lessons", "online boxing coach"],
  },
  {
    q: "How long is each session?",
    a: "Each live virtual session is 40 minutes — long enough to warm up, drill technique, work combinations, and condition; short enough to stay sharp and focused. The BTB Basics Program runs 6 weekly sessions over 6 weeks.",
  },
  {
    q: "What equipment do I need for virtual boxing lessons?",
    a: "Honestly, nothing required to start. A clear space (about 6 ft × 6 ft), a phone or laptop with a camera, and water nearby. As you progress, hand wraps and gloves are nice-to-have but not essential — Coach Chris will recommend gear based on where you are in your training.",
  },
  {
    q: "How much space do I need at home?",
    a: "Six feet by six feet is plenty for shadow boxing, footwork drills, and defense work. If you have more space, great — but Coach Chris designs every drill around what you've got. Several clients train in apartments without any issue.",
  },
  {
    q: "What's included in the BTB Basics Program?",
    a: "Six weekly 40-minute private Zoom sessions covering: stance and guard, footwork patterns (the box step, pivots, angles), the Core 4 punches (jab, cross, lead hook, rear hook), basic defense (slips, parries, blocks), and conditioning. Completing the program unlocks the $70 alumni rate on all future single sessions — forever.",
    keywords: ["BTB program", "Better Through Boxing program"],
  },
  {
    q: "How is this different from boxing videos on YouTube?",
    a: "YouTube can teach you what a punch looks like. It can't tell you that your back foot is flat, your shoulder is dropping, or that you're telegraphing your jab. Live coaching catches those mistakes in the moment — that's the whole difference between learning boxing and just watching boxing.",
    keywords: ["online boxing coach", "boxing fitness coaching online"],
  },
  {
    q: "Will I actually get a workout, or is it all technique?",
    a: "Both. Boxing fitness comes from doing the technique correctly and at pace. You'll be drilling combinations, footwork, and defensive work for 40 minutes — most clients are sweating by minute 10. The fitness is real; it's just earned through technique, not generic cardio.",
    keywords: ["boxing fitness coaching online"],
  },
  {
    q: "Can you teach me footwork over Zoom?",
    a: "Yes — footwork is one of the things that translates best to virtual training, because Coach Chris can see your feet, your weight distribution, and your stance from a camera angle better than from across a gym. Box-step patterns, pivots, lateral movement, angle creation — all teachable over Zoom.",
    keywords: ["boxing footwork training online"],
  },
  {
    q: "How do I schedule my sessions?",
    a: "After you pay, Coach Chris contacts you within 24 hours (phone, text, or email) to coordinate a time that works for both of you. You don't pick a fixed slot at checkout — sessions are scheduled around your real availability.",
  },
  {
    q: "Can I reschedule or cancel?",
    a: "Yes — reschedule any confirmed session for free if you give 24+ hours notice. Cancellations under 24 hours, no-shows, or arriving more than 10 minutes late forfeit that session. Coach-initiated cancellations are always rescheduled at no cost.",
  },
  {
    q: "How do I pay?",
    a: "Securely through Stripe — credit card, debit card, Apple Pay, or Google Pay. All payments are non-refundable, but unused sessions can be rescheduled per the policy above.",
  },
  {
    q: "Do you offer in-person training?",
    a: "Yes — Coach Chris offers limited 1-on-1 in-person sessions across North and Central New Jersey. Slots are limited and each request is coach-vetted personally. NJ residents can request in-person training from the In-Person page.",
  },
  {
    q: "What's the alumni rate?",
    a: "Once you complete the BTB Basics Program ($699), you unlock the alumni rate of $70 per single virtual session (vs. the standard $100). It's a permanent discount — the cheapest way to keep training long-term.",
  },
  {
    q: "What experience does Coach Chris have?",
    a: "Coach Chris Persaud has spent the last 7+ years coaching boxing — from absolute beginners on day one to active amateurs preparing for fights. He founded The Flow State Method LLC to bring that same coaching quality online, with the Better Through Boxing program as its flagship offering.",
  },
];
